<template>
    <div>
        <label class="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-2">
            {{ label }}
            <span class="text-red-500" aria-hidden="true" v-if="required">*</span>
        </label>
        <div class="flex flex-wrap gap-2">
            <button
                v-for="option in options"
                :key="option.value"
                type="button"
                @click="$emit('update:modelValue', option.value)"
                :class="[
                    'px-4 py-2 rounded-lg border text-sm font-medium transition-colors',
                    modelValue === option.value
                        ? 'border-orange-500 bg-orange-50 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300 dark:border-orange-500/60'
                        : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:border-slate-500',
                ]"
            >
                {{ option.label }}
            </button>
        </div>
        <p v-if="hint" class="mt-1.5 text-xs text-slate-500 dark:text-slate-400">{{ hint }}</p>
        <p v-if="errorMessage" class="mt-1.5 text-sm text-red-600 dark:text-red-400">
            {{ errorMessage }}
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    label: { type: String, required: true },
    name: { type: String, required: true },
    modelValue: { type: [String, Boolean, null], default: null },
    options: { type: Array, required: true },
    errors: { type: Object, default: null },
    hint: { type: [String, null], default: null },
    required: { type: Boolean, default: false },
});

defineEmits(['update:modelValue']);

const errorMessage = computed(() => {
    const fieldErrors = props.errors?.[props.name];
    return Array.isArray(fieldErrors) ? fieldErrors[0] : null;
});
</script>
